import type { TranscriptSpeakerPayload } from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakersFetched';

// `DELETE …/transcript/speakers/:speaker/assignment` answers the same shape as an assignment (§5.6a):
// the speaker is never deleted, only reset to `unassigned`.
export type TranscriptSpeakerUnassignedAction = {
	type: 'TRANSCRIPT_SPEAKER_UNASSIGNED';
	payload: TranscriptSpeakerPayload;
	interviewId: number;
};

export default (
	payload: TranscriptSpeakerPayload,
	interviewId: number,
): TranscriptSpeakerUnassignedAction => ({
	type: 'TRANSCRIPT_SPEAKER_UNASSIGNED',
	payload,
	interviewId,
});
